/* eslint-disable  */
import React, { useEffect, useState } from "react";
import RenderHirePurchasePage from "../RenderHirePurchasePage";
import { GetUserProfile } from "../../services/Actions/authActions";
import { dataActionCreators } from "../../services/Actions";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { RolesContants } from "../../contants";
import { GetMartReport } from "../../services/Actions/dataAction";
import { FaDownload, FaRegFilePdf } from "react-icons/fa";

// Inline button spinner
function Spinner() {
  return (
    <svg
      className="animate-spin h-4 w-4 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

function HirePurchaseReport() {
  const dispatch = useDispatch();

  const { ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  const [formData, setFormData] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });
  // Which button triggered the current download: "status" | "all" | null
  const [activeAction, setActiveAction] = useState(null);

  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  const { isLoading, response } = data;

  useEffect(() => {
    dispatch(GetUserProfile());
  }, []);

  // Clear the active button once the download finishes
  useEffect(() => {
    if (!isLoading) setActiveAction(null);
  }, [isLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const isAuthorized = () =>
    user?.role?.includes(RolesContants.ADMIN) ||
    user?.role?.includes(RolesContants.MART_OFFICER) ||
    user?.role?.includes(RolesContants.MART_OFFICER_HEAD);

  const handleGenerate = () => {
    if (!isAuthorized()) {
      toast.error("You are not authorized to generate report on orders");
      return;
    }
    if (!formData.category) {
      toast.error("Select a status to generate the report");
      return;
    }
    if (!formData.fromDate || !formData.toDate) {
      toast.error("Choose the date range. This is required");
      return;
    }
    setActiveAction("status");
    dispatch(GetMartReport(formData.category, formData.fromDate, formData.toDate));
  };

  const handleGenerateAll = () => {
    if (!isAuthorized()) {
      toast.error("You are not authorized to generate report on orders");
      return;
    }
    if (!formData.fromDate || !formData.toDate) {
      toast.error("Choose the date range. This is required");
      return;
    }
    setActiveAction("all");
    dispatch(GetMartReport("all", formData.fromDate, formData.toDate));
  };

  return (
    <RenderHirePurchasePage title="Report">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 sm:p-8 mt-2">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30 mb-3">
            <FaRegFilePdf className="text-indigo-600 dark:text-indigo-400 text-xl" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">
            Generate Report
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-2">
          <div>
            <label
              htmlFor="category"
              className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1"
            >
              Status
            </label>
            <select
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
            >
              <option value="" disabled>
                Select Status
              </option>
              <option value="initiated">Initiated Orders</option>
              <option value="approved">Approved Orders</option>
              <option value="shipped">Shipped Orders</option>
              <option value="rejected">Rejected Orders</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="fromDate"
              className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1"
            >
              From
            </label>
            <input
              type="date"
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              id="fromDate"
              name="fromDate"
              value={formData.fromDate}
              onChange={handleChange}
            />
          </div>

          <div>
            <label
              htmlFor="toDate"
              className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1"
            >
              To
            </label>
            <input
              type="date"
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
              id="toDate"
              name="toDate"
              value={formData.toDate}
              onChange={handleChange}
            />
          </div>
        </div>

        <p className="text-xs text-slate-500 dark:text-slate-400 text-center mb-6">
          Pick a status and date range to generate, or use{" "}
          <span className="font-medium">Generate All</span> to export every order
          within the date range.
        </p>

        <div className="flex items-center justify-center gap-3 pt-4 border-t border-slate-100 dark:border-gray-700">
          <button
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
            onClick={handleGenerate}
            disabled={isLoading}
          >
            {isLoading && activeAction === "status" ? (
              <>
                <Spinner /> Generating...
              </>
            ) : (
              <>
                <FaDownload /> Generate
              </>
            )}
          </button>
          <button
            onClick={handleGenerateAll}
            disabled={isLoading}
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {isLoading && activeAction === "all" ? (
              <>
                <Spinner /> Generating...
              </>
            ) : (
              <>
                <FaDownload /> Generate All
              </>
            )}
          </button>
        </div>
      </div>

      <ToastContainer autoClose={3000} />
    </RenderHirePurchasePage>
  );
}

export default HirePurchaseReport;
